import { createService } from "./createService"
import { SERVICE_INSTANCES } from "./serviceInstances"

const service = createService(SERVICE_INSTANCES.payroll)

export const PAYROLL_INSTANCE = service.instanceKey

export const PAYROLL_ENDPOINTS = {
  VIEW_INDEX: "/admin/payrolls/view/index",
  VIEW_ITEMS: "/payrolls/view/items",
  ADMIN_VIEW_ITEMS: "/admin/payrolls/view/items",
  VIEW_CURRENCIES: "/admin/payrolls/view/currencies",
  GET: "/admin/payrolls/get",
  GET_CHANGE_TYPES: "/admin/payrolls/getchangetypes",
  GET_CHANGE: "/admin/payrolls/getchange",
  GET_PERSON_COUNT: "/admin/payrolls/getpersoncount",
  ADD_CHANGE: "/admin/payrolls/add_change",
  SELECT_CHANGES: "/admin/payrolls/selectpayrollchanges",
  SELECT_CHANGES_APPROVAL: "/payrolls/selectpayrollchanges",
  SELECT_RECORDS_APPROVAL: "/payrolls/selectpayrollrecords",
  SKIP_PERSONS_UPCOMING: "/admin/payrolls/skip_persons_upcoming",
  SELECT_RECORDS: "/admin/payrolls/selectpayrollrecords",
  SELECT_TAKE_HOME_SUMMARY: "/admin/payrolls/selectpayrollitemtakehomesummary",
  SELECT_TEMP_TAKE_HOME_SUMMARY:
    "/admin/payrolls/selecttemppayrollitemtakehomesummary",
  SELECT_TAKE_HOME_COMPARE:
    "/admin/payrolls/selectpayrollitemtakehomesummarycompare",
  SELECT_PAYROLL_ITEM_TOTALS: "/admin/payrolls/selectpayrollitemtotals",
  SELECT_TEMP_PAYROLL_ITEM_TOTALS:
    "/admin/payrolls/selecttemppayrollitemtotals",
  SELECT_COMPANY_COST_SUMMARY:
    "/admin/payrolls/selectpayrollitemcompanycostsummary",
  SELECT_TEMP_COMPANY_COST_SUMMARY:
    "/admin/payrolls/selecttemppayrollitemcompanycostsummary",
  SELECT_COMPANY_COST_COMPARE:
    "/admin/payrolls/selectpayrollitemcompanycostsummarycompare",
  SELECT_TEMP_COMPANY_COST_COMPARE:
    "/admin/payrolls/selecttemppayrollitemcompanycostsummarycompare",
  GET_APPROVED: "/admin/payrolls/getapprovedpayrolls",
  REVIEW: "/admin/payrolls/review",
  REVIEW_CHANGE: "/admin/payrolls/review_change",
  BATCH_REVIEW_CHANGE: "/admin/payrolls/batch_review_change",
  DELETE_CHANGE: "/admin/payrolls/delete_change",
  UPDATE_CHANGE_STATUS: "/admin/payrolls/update_change_status",
  CANCEL: "/admin/payrolls/cancel",
  RESTART_APPROVAL: "/admin/payrolls/restart_approval",
  ARCHIVE: "/admin/payrolls/archive",
  RESTORE: "/admin/payrolls/restore",
  PREPARE: "/admin/payrolls/prepare",
  CREATE_REGULAR: "/admin/payrolls/create_regular_payrolls_for_current_month",
  CREATE_CUSTOM: "/admin/payrolls/create_custom_payrolls_for_current_month",
  // Payables
  GET_PAYABLE_TYPES: "/employee/payables/getpayabletypes",
  GET_PAYABLE_TYPE_RATE: "/employee/payables/getpayabletyperate",
  GET_PAYABLE_TYPE_RATE_ADMIN: "/admin/payrolls/getpayabletyperate",
  // Bulk change upload
  BULK_CHANGE_UPLOAD: "/admin/payrolls/bulk_change_upload",
  // Email payslip
  EMAIL_SINGLE_PAYSLIP: "/admin/payrolls/email_single_payslip",
  // Email payslips (batch)
  EMAIL_PAYSLIPS: "/admin/payrolls/email_payslips",
  // Payslip distribution status
  PAYSLIP_DISTRIBUTION_STATUS: "/admin/payrolls/payslip_distribution_status",
  // Email payslips attachment
  EMAIL_PAYSLIPS_ATTACHMENT: "/admin/payrolls/email_payslips_attachment",
  // Upload payslips
  UPLOAD_PAYSLIPS: "/admin/payrolls/upload_payslips",
  // Payslip payroll years
  GET_PAYROLL_YEARS: "/employee/payslips/getpayrollyears",
  // Delete on-demand payroll
  DELETE_ONDEMAND_PAYROLL: "/admin/payrolls/delete_ondemand_payroll",
  // Create monthly payrolls
  CREATE_MONTHLY_PAYROLLS: "/admin/payrolls/create_monthly_payrolls",
  // Create on-demand payroll
  CREATE_ONDEMAND_PAYROLL: "/admin/payrolls/create_ondemand_payroll",
  VIEW_ONDEMAND_PAYROLL: "/admin/payrolls/view/ondemandpayroll",
  // Create payroll change from payroll
  CREATE_PAYROLL_CHANGE_FROM_PAYROLL:
    "/admin/payrolls/createpayrollchangefrompayroll",
  // View new
  VIEW_NEW: "/admin/payrolls/view/new",
  // View report summary
  VIEW_REPORT_SUMMARY: "/payrolls/view/report_summary",
  // View report variance
  VIEW_REPORT_VARIANCE: "/admin/payrolls/view/report_variance",
  // View receipt
  VIEW_RECEIPT: "/admin/payrolls/view/receipt",
  // Get current status
  GET_CURRENT_STATUS: "/admin/payrolls/getcurrentstatus",
  // Refresh
  REFRESH: "/admin/payrolls/refresh",
  // Submit
  SUBMIT: "/admin/payrolls/submit",
  // Add multiple changes
  ADD_MULTIPLE_CHANGES: "/admin/payrolls/add_multiple_changes",
  // Upload change file
  UPLOAD_CHANGE_FILE: "/admin/payrolls/upload_changefile",
  // Skip persons
  SKIP_PERSONS: "/admin/payrolls/skip_persons",
  // Import exemptions
  IMPORT_EXEMPTIONS: "/admin/payrolls/import_exemptions",
  DOWNLOAD_BULK_EXEMPTION_FORM:
    "/admin/payrolls/view/download_bulk_exemption_upload_form",
  IMPORT_CHANGES: "/admin/payrolls/import_changes",
  // Fusion allowance days (Oracle integration)
  IMPORT_FUSION_ALLOWANCE_DAYS: "/admin/payrolls/import_fusion_allowance_days",
  DOWNLOAD_BULK_FUSION_ALLOWANCE_DAYS_FORM:
    "/admin/payrolls/view/download_bulk_fusion_allowance_days_upload_form",
  // Payable types CRUD
  ADD_PAYABLE_TYPE: "/admin/payrolls/add_payabletype",
  UPDATE_PAYABLE_TYPE: "/admin/payrolls/update_payabletype",
  DELETE_PAYABLE_TYPE: "/admin/payrolls/delete_payable_type",
  VIEW_PAYABLE_TYPES: "/admin/payrolls/view/payabletypes",
  CHECK_PAYABLE_TYPE: "/admin/payrolls/checkpayabletype",
  GET_PAYABLE_TYPE_UNITS: "/admin/payrolls/getpayabletypeunits",
  // Payable type units CRUD
  ADD_PAYABLE_TYPE_UNIT: "/admin/payrolls/add_payable_type_unit",
  UPDATE_PAYABLE_TYPE_UNIT: "/admin/payrolls/update_payable_type_unit",
  DELETE_PAYABLE_TYPE_UNIT: "/admin/payrolls/delete_payable_type_unit",
  // Report summary
  SELECT_PAYROLLS_FOR_REPORT_SUMMARY:
    "/admin/payrolls/selectpayrollsforreportsummary",
  // Check Payable type name
  CHECK_PAYABLE_TYPE_NAME: "/admin/payrolls/checkpayabletype",
  // Check Payable type
  VIEW_PAYABLE_TYPE: "/admin/payrolls/view/payabletypes",
  // Check Payable type
  GET_DEDUCTION_TYPES: "/admin/payrolls/getdeductiontypes",
  // Check Payable type
  GET_PAYABLES_TYPES: "/admin/payrolls/getpayabletypes",
  // Employee get currency symbol
  EMPLOYEE_GET_CURRENCY_SYMBOL: "/admin/employees/getcurrencysymbol",

  // Employee get currency symbol
  PAYROLL_GET_EMPLOYEE: "/admin/payrolls/getemployees",

  // Employee get currency symbol
  PAYROLL_LEDGER_SYNC: "/admin/payrolls/payroll-ledger-sync",

  GET_EMPLOYEES: "/admin/payrolls/getemployees",

  // View skip employees
  VIEW_SKIP_EMPLOYEES: "/admin/payrolls/view/skip_employees",
  // Select skipped employees
  SELECT_SKIPPED_EMPLOYEES: "/admin/payrolls/selectskippedemployees",
  // View consolidated payslips
  VIEW_CONSOLIDATED_PAYSLIPS: "/admin/payrolls/view/consolidated_payslips",
  // Employee payslip years (used by consolidated payslip)
  GET_PAYSLIP_YEARS: "/employee/payslips/getpayrollyears",
} as const

export const payrollService = {
  instanceKey: service.instanceKey,

  viewIndex: (currency?: string) =>
    service.get(
      PAYROLL_ENDPOINTS.VIEW_INDEX,
      currency ? { currency } : undefined
    ),
  viewItems: (key: string) =>
    service.get(PAYROLL_ENDPOINTS.VIEW_ITEMS, { id: key }),
  adminViewItems: (key: string) =>
    service.get(PAYROLL_ENDPOINTS.ADMIN_VIEW_ITEMS, { id: key }),
  getCurrencies: () => service.get(PAYROLL_ENDPOINTS.VIEW_CURRENCIES),
  get: (params?: Record<string, any>) =>
    service.get(PAYROLL_ENDPOINTS.GET, params),
  getPayPeriods: (body?: Record<string, any>) =>
    service.get(PAYROLL_ENDPOINTS.GET, body),
  getChangeTypes: (
    opts: { recordTypeValue?: string; id?: string | number } = {}
  ) =>
    service.get(PAYROLL_ENDPOINTS.GET_CHANGE_TYPES, {
      ...(opts.recordTypeValue !== undefined && {
        forEmployee: opts.recordTypeValue === "employee",
      }),
      ...(opts.id !== undefined && { id: opts.id }),
    }),
  getChange: (id: string | number) =>
    service.get(`${PAYROLL_ENDPOINTS.GET_CHANGE}?id=${id}`, {}),
  getPersonCount: (id: string | number) =>
    service.get(PAYROLL_ENDPOINTS.GET_PERSON_COUNT, { id }),
  addChange: (body: Record<string, any>) =>
    service.post(PAYROLL_ENDPOINTS.ADD_CHANGE, body),
  selectChanges: (params?: Record<string, any>) =>
    service.get(PAYROLL_ENDPOINTS.SELECT_CHANGES, params),
  selectChangesAdmin: (
    statusId?: string | number,
    params?: { pageNumber?: number; pageSize?: number; searchParams?: string }
  ) => service.get(PAYROLL_ENDPOINTS.SELECT_CHANGES, { statusId, ...params }),
  selectChangesApproval: (params: Record<string, any>) =>
    service.get(PAYROLL_ENDPOINTS.SELECT_CHANGES_APPROVAL, params),
  selectRecordsApproval: (params: Record<string, any>) =>
    service.get(PAYROLL_ENDPOINTS.SELECT_RECORDS_APPROVAL, params),
  skipPersonsUpcoming: (body: Record<string, any>[]) =>
    service.post(PAYROLL_ENDPOINTS.SKIP_PERSONS_UPCOMING, body),
  selectRecords: (params?: Record<string, any>) =>
    service.get(PAYROLL_ENDPOINTS.SELECT_RECORDS, params),
  selectTakeHomeSummary: (body: Record<string, any>) =>
    service.post(PAYROLL_ENDPOINTS.SELECT_TAKE_HOME_SUMMARY, body),
  selectTakeHomeCompare: (body: Record<string, any>) =>
    service.post(PAYROLL_ENDPOINTS.SELECT_TAKE_HOME_COMPARE, body),
  selectCompanyCostSummary: (body: Record<string, any>) =>
    service.post(PAYROLL_ENDPOINTS.SELECT_COMPANY_COST_SUMMARY, body),
  selectCompanyCostCompare: (body: Record<string, any>) =>
    service.post(PAYROLL_ENDPOINTS.SELECT_COMPANY_COST_COMPARE, body),
  getApproved: () => service.get(PAYROLL_ENDPOINTS.GET_APPROVED),

  // Review / approve / decline
  review: (id: string | number, comment: string, actionType: string) =>
    service.post(
      `${PAYROLL_ENDPOINTS.REVIEW}?id=${id}&comment=${encodeURIComponent(
        comment
      )}&actionType=${actionType}`
    ),
  reviewChange: (
    id: string | number,
    note: string,
    actionType: string,
    isForPayroll?: string | null
  ) =>
    service.post(
      `${PAYROLL_ENDPOINTS.REVIEW_CHANGE}?id=${id}&note=${encodeURIComponent(
        note
      )}&actionType=${actionType}${
        isForPayroll != null ? `&is_for_payroll=${isForPayroll}` : ""
      }`
    ),
  batchReviewChange: (
    actionType: string,
    isForPayroll: string | null,
    data: Record<string, any>[]
  ) =>
    service.post(
      `${PAYROLL_ENDPOINTS.BATCH_REVIEW_CHANGE}?id=${actionType}${
        isForPayroll != null ? `&is_for_payroll=${isForPayroll}` : ""
      }`,
      data
    ),

  // Change management
  deleteChange: (id: string | number) =>
    service.post(`${PAYROLL_ENDPOINTS.DELETE_CHANGE}?id=${id}`),
  deleteChangesBatch: (body: { id: number | string }[]) =>
    service.post(PAYROLL_ENDPOINTS.DELETE_CHANGE, body),
  updateChangeStatus: (id: string | number) =>
    service.post(`${PAYROLL_ENDPOINTS.UPDATE_CHANGE_STATUS}?id=${id}`),
  updateChangeStatuses: (body: { id: string | number }[]) =>
    service.post(PAYROLL_ENDPOINTS.UPDATE_CHANGE_STATUS, body),

  // Payroll lifecycle
  cancel: (id: string | number, comment?: string) =>
    service.post(
      `${PAYROLL_ENDPOINTS.CANCEL}?id=${id}${
        comment ? `&comment=${encodeURIComponent(comment)}` : ""
      }`
    ),
  restartApproval: (id: string | number, comment?: string) =>
    service.post(
      `${PAYROLL_ENDPOINTS.RESTART_APPROVAL}?id=${id}${
        comment ? `&comment=${encodeURIComponent(comment)}` : ""
      }`
    ),
  archive: (id: string | number) =>
    service.post(`${PAYROLL_ENDPOINTS.ARCHIVE}?id=${id}`),
  restore: (id: string | number) =>
    service.post(`${PAYROLL_ENDPOINTS.RESTORE}?id=${id}`),
  prepare: (id: string | number) =>
    service.post(`${PAYROLL_ENDPOINTS.PREPARE}?id=${id}`),
  createRegular: () => service.post(PAYROLL_ENDPOINTS.CREATE_REGULAR),
  createCustom: () => service.post(PAYROLL_ENDPOINTS.CREATE_CUSTOM),

  // Payables
  getPayableTypes: () => service.get(PAYROLL_ENDPOINTS.GET_PAYABLE_TYPES),
  getPayableTypeRate: (params?: Record<string, any>) =>
    service.get(PAYROLL_ENDPOINTS.GET_PAYABLE_TYPE_RATE, params),
  getPayableTypeRateAdmin: (body: Record<string, any>) =>
    service.post(PAYROLL_ENDPOINTS.GET_PAYABLE_TYPE_RATE_ADMIN, body),

  // Bulk upload
  bulkChangeUpload: (formData: FormData) =>
    service.upload(PAYROLL_ENDPOINTS.BULK_CHANGE_UPLOAD, formData),

  // Email payslip
  emailSinglePayslip: (payrollId: string | number, personId: string | number) =>
    service.post(
      `${PAYROLL_ENDPOINTS.EMAIL_SINGLE_PAYSLIP}?id=${payrollId}&x=${personId}`
    ),

  // Upload payslips
  uploadPayslips: (id: string | number) =>
    service.post(`${PAYROLL_ENDPOINTS.UPLOAD_PAYSLIPS}?id=${id}`),

  // Email payslips (batch)
  emailPayslips: (id: string | number) =>
    service.post(`${PAYROLL_ENDPOINTS.EMAIL_PAYSLIPS}?id=${id}`),

  // Payslip distribution status
  payslipDistributionStatus: (id: string | number) =>
    service.get(`${PAYROLL_ENDPOINTS.PAYSLIP_DISTRIBUTION_STATUS}?id=${id}`),

  // Email payslips attachment
  emailPayslipsAttachment: (
    id: string | number,
    personIds?: Array<string | number>
  ) =>
    service.post(`${PAYROLL_ENDPOINTS.EMAIL_PAYSLIPS_ATTACHMENT}?id=${id}`, {
      personIds,
    }),

  // Delete on-demand payroll
  deleteOndemandPayroll: (id: string | number) =>
    service.post(`${PAYROLL_ENDPOINTS.DELETE_ONDEMAND_PAYROLL}?id=${id}`),

  // Create monthly payrolls
  createMonthlyPayrolls: (body: Record<string, any>) =>
    service.post(PAYROLL_ENDPOINTS.CREATE_MONTHLY_PAYROLLS, body),

  // Create on-demand payroll
  createOndemandPayroll: (body: Record<string, any>) =>
    service.post(PAYROLL_ENDPOINTS.CREATE_ONDEMAND_PAYROLL, body),

  // Create payroll change from payroll
  createPayrollChangeFromPayroll: (
    id: string | number,
    body: Record<string, any>
  ) =>
    service.post(
      `${PAYROLL_ENDPOINTS.CREATE_PAYROLL_CHANGE_FROM_PAYROLL}?id=${id}`,
      body
    ),

  // View new payroll
  viewNew: (key: string) =>
    service.get(PAYROLL_ENDPOINTS.VIEW_NEW, { id: key }),

  // View report summary
  viewReportSummary: (id: string, isApproval?: boolean, staffCategory?: string) =>
    service.get(
      `${isApproval ? "" : "/admin"}${PAYROLL_ENDPOINTS.VIEW_REPORT_SUMMARY}`,
      { id, staffCategory }
    ),

  // Get current status
  getCurrentStatus: (id: string | number) =>
    service.get(`${PAYROLL_ENDPOINTS.GET_CURRENT_STATUS}?id=${id}`),

  // Refresh payroll
  refresh: (id: string | number) =>
    service.post(`${PAYROLL_ENDPOINTS.REFRESH}?id=${id}`),

  // Submit payroll
  submitPayroll: (body: Record<string, any>) =>
    service.post(PAYROLL_ENDPOINTS.SUBMIT, body),

  // Add multiple changes
  addMultipleChanges: (body: Record<string, any>) =>
    service.post(PAYROLL_ENDPOINTS.ADD_MULTIPLE_CHANGES, body),

  // Upload change file
  uploadChangeFile: (id: string | number, formData: FormData) =>
    service.upload(
      `${PAYROLL_ENDPOINTS.UPLOAD_CHANGE_FILE}?id=${id}`,
      formData
    ),

  // Skip persons from specific payroll
  skipPersons: (payrollId: string | number, body: Record<string, any>) =>
    service.post(`${PAYROLL_ENDPOINTS.SKIP_PERSONS}?id=${payrollId}`, body),

  // Import exemptions (bulk skip)
  importExemptions: (formData: FormData) =>
    service.upload(PAYROLL_ENDPOINTS.IMPORT_EXEMPTIONS, formData),

  // Import payroll changes (bulk upload)
  importChanges: (formData: FormData) =>
    service.upload(PAYROLL_ENDPOINTS.IMPORT_CHANGES, formData),

  // Import fusion allowance days (bulk upload)
  importFusionAllowanceDays: (formData: FormData) =>
    service.upload(PAYROLL_ENDPOINTS.IMPORT_FUSION_ALLOWANCE_DAYS, formData),

  // Payable types
  addPayableType: (body: Record<string, any>) =>
    service.post(PAYROLL_ENDPOINTS.ADD_PAYABLE_TYPE, body),
  updatePayableType: (id: string | number, body: Record<string, any>) =>
    service.post(`${PAYROLL_ENDPOINTS.UPDATE_PAYABLE_TYPE}?id=${id}`, body),
  deletePayableType: (id: string | number) =>
    service.post(`${PAYROLL_ENDPOINTS.DELETE_PAYABLE_TYPE}?id=${id}`),

  // Payable type units
  addPayableTypeUnit: (body: Record<string, any>) =>
    service.post(PAYROLL_ENDPOINTS.ADD_PAYABLE_TYPE_UNIT, body),
  updatePayableTypeUnit: (id: string | number, body: Record<string, any>) =>
    service.post(
      `${PAYROLL_ENDPOINTS.UPDATE_PAYABLE_TYPE_UNIT}?id=${id}`,
      body
    ),
  deletePayableTypeUnit: (id: string | number, data: any) =>
    service.post(
      `${PAYROLL_ENDPOINTS.DELETE_PAYABLE_TYPE_UNIT}?id=${id}`,
      data
    ),

  // Select payrolls for report summary
  selectPayrollsForReportSummary: (params?: Record<string, unknown>) =>
    service.get(PAYROLL_ENDPOINTS.SELECT_PAYROLLS_FOR_REPORT_SUMMARY, {
      ...params,
    }),

  // Temp payroll totals (payperiod step 2 preview)
  selectTempPayrollTotals: (payrollId: string | number) =>
    service.get(
      `${PAYROLL_ENDPOINTS.SELECT_TEMP_PAYROLL_ITEM_TOTALS}?payroll_id=${payrollId}`
    ),

  // Non-temp payroll item totals
  selectPayrollItemTotals: (payrollId: string | number) =>
    service.get(
      `${PAYROLL_ENDPOINTS.SELECT_PAYROLL_ITEM_TOTALS}?payroll_id=${payrollId}`
    ),

  // Take-home summary (supports temp/non-temp) — used by WhatEmployeesTakeHome panel
  selectTakeHomeSummaryByPayrollId: (
    payrollId: string | number,
    isTemp?: boolean,
    params?: Record<string, unknown>
  ) =>
    service.get(
      `${
        isTemp
          ? PAYROLL_ENDPOINTS.SELECT_TEMP_TAKE_HOME_SUMMARY
          : PAYROLL_ENDPOINTS.SELECT_TAKE_HOME_SUMMARY
      }`,
      { payroll_id: payrollId, ...params }
    ),

  // Company cost summary (supports temp/non-temp) — used by WhatCompanyPays panel
  selectCompanyCostSummaryByPayrollId: (
    payrollId: string | number,
    isTemp?: boolean,
    params?: Record<string, unknown>
  ) =>
    service.get(
      `${
        isTemp
          ? PAYROLL_ENDPOINTS.SELECT_TEMP_COMPANY_COST_SUMMARY
          : PAYROLL_ENDPOINTS.SELECT_COMPANY_COST_SUMMARY
      }`,
      { payroll_id: payrollId, ...params }
    ),

  // Take-home compare (supports temp/non-temp) — used by WhatEmployeesTakeHomeCompare panel
  selectTakeHomeCompareByPayrollId: (
    payrollId: string | number,
    isTemp?: boolean,
    params?: Record<string, unknown>
  ) =>
    service.get(
      `/admin/payrolls/${
        isTemp ? "selecttemp" : "select"
      }payrollitemtakehomesummarycompare`,
      { payroll_id: payrollId, ...params }
    ),

  // Company cost compare (supports temp/non-temp) — used by WhatCompanyPaysCompare panel
  selectCompanyCostCompareByPayrollId: (
    payrollId: string | number,
    isTemp?: boolean,
    params?: Record<string, unknown>
  ) =>
    service.get(
      `${
        isTemp
          ? PAYROLL_ENDPOINTS.SELECT_TEMP_COMPANY_COST_COMPARE
          : PAYROLL_ENDPOINTS.SELECT_COMPANY_COST_COMPARE
      }`,
      { payroll_id: payrollId, ...params }
    ),

  // View on-demand payroll
  viewOndemandPayroll: (id: string | number) =>
    service.get(PAYROLL_ENDPOINTS.VIEW_ONDEMAND_PAYROLL, { id }),

  // View skip employees
  viewSkipEmployees: (id?: string | number) =>
    service.get(PAYROLL_ENDPOINTS.VIEW_SKIP_EMPLOYEES, id ? { id } : undefined),

  // Select skipped employees
  selectSkippedEmployees: (params?: Record<string, any>) =>
    service.get(PAYROLL_ENDPOINTS.SELECT_SKIPPED_EMPLOYEES, params),

  // Get admin payable types (distinct from employee version)
  getAdminPayableTypes: () => service.get(`/admin/payrolls/getpayabletypes`),

  // Get payroll
  getPayroll: (body?: Record<string, any>) =>
    service.post(`/admin/payrolls/get`, body || { q: "", page: "" }),

  // View report variance
  viewReportVariance: (id: string | number) =>
    service.get(PAYROLL_ENDPOINTS.VIEW_REPORT_VARIANCE, { id }),

  // View payslips
  viewPayslips: (id: string | number) =>
    service.get(`/admin/payrolls/view/payslips`, { id }),

  // View receipt
  viewReceipt: (id: string | number) =>
    service.get(PAYROLL_ENDPOINTS.VIEW_RECEIPT, { id }),

  // View consolidated payslips
  viewConsolidatedPayslips: (payrollYear: string | number) =>
    service.get(PAYROLL_ENDPOINTS.VIEW_CONSOLIDATED_PAYSLIPS, {
      payroll_year: payrollYear,
    }),

  // View payable types
  viewPayableTypes: (params: { id: string; x?: string }) =>
    service.get(PAYROLL_ENDPOINTS.VIEW_PAYABLE_TYPES, params),

  // Check payable type name
  checkPayableType: (description: string) =>
    service.get(`/admin/payrolls/checkpayabletype`, { description, id: "-1" }),

  // Get payable type units
  getPayableTypeUnits: () =>
    service.get(PAYROLL_ENDPOINTS.GET_PAYABLE_TYPE_UNITS),

  // Get deduction types
  getDeductionTypes: () => service.get(`/admin/payrolls/getdeductiontypes`),

  // Deduction type mutations
  addDeductionType: (body: Record<string, any>) =>
    service.post(`/admin/payrolls/add_deductiontype`, body),
  updateDeductionType: (id: string | number, body: Record<string, any>) =>
    service.post(`/admin/payrolls/update_deductiontype?id=${id}`, body),
  deleteDeductionType: (id: string | number) =>
    service.post(`/admin/payrolls/delete_deduction_type?id=${id}`),

  // Employee payslip years (used by consolidated payslip)
  getPayslipYears: () => service.get(PAYROLL_ENDPOINTS.GET_PAYROLL_YEARS),

  // Get employees for a specific payroll
  getPayrollEmployees: (payrollId: string | number) =>
    service.get(`/admin/payrolls/getemployees`, { id: payrollId }),
  // Get employees for a specific payroll
  payrollLedgeSync: (id: string | number) =>
    service.post(`/admin/payrolls/payroll-ledger-sync?id=${id}`),
  getEmployeeCurrencySymbol: (personId: string | number) =>
    service.get(PAYROLL_ENDPOINTS.EMPLOYEE_GET_CURRENCY_SYMBOL, {
      id: personId,
    }),
}
